import { createStore } from 'redux';

const initial={};

/**
* To save any custome details using reducx store concept 
* @state we set the empty object for store our custome details
* @action we pass the type and payload in a object format like  			{type:catageryname,payload:stored date}
**/
function reducer(state:initial,action) {
  switch (action.type) {
     case 'PROFILE':
	  return {
        ...state,
        profile: action.payload,
      };
	 case 'VACCINATION':
      return {
        ...state,
        vaccination: action.payload,
      };
	  case 'DEVELOPMENT':
      return {
        ...state,
        development: action.payload,
      };
	 case 'RESET':
	 return initial;
	default:
      return state;
	}
}

const store=createStore(reducer);
export default store;

